export default __webpack_public_path__ + "static/logo_watermark-1e2d1690ca4daad5f10659e64976e5cc.png";